import { Employee } from './employee.model';
import { Representative } from './representative.model';

interface ApplicationProfileCoalitionResponse {
  $id: number;
  CoalitionId: number;
  Name: string;
  InternalPortalDomain: string;
  MerchantPortalDomain: string;
}

interface ApplicationProfileRepresentativeResponse {
  $id: number;
  RepresentativeId: number;
  CoalitionId: number;
  NameFirst: string;
  NameLast: string;
  EmailAddress: string;
  PhoneNumber: string;
  AccessType: number;
  StatusType: number;
  Coalition: ApplicationProfileCoalitionResponse;
  PortalTheme?: ApplicationProfilePortalTheme;
}

export interface ApplicationProfile {
  Representative: ApplicationProfileRepresentativeResponse;
}

interface ApplicationProfilePortalTheme {
  Theme?: PortalTheme;
  PrimaryLogo?: string;
  SecondaryLogo?: string;
  FavIcon?: string;
  PendingPrimaryLogo?: string;
  PendingSecondaryLogo?: string;
  PendingFavIcon?: string;
}

export interface PortalTheme {
  primary: string;
  backgroundColor: string;
  defaultTextColor: string;
  sidebar: {
    backgroundColor: {
      primary: string;
      secondary: string;
      active: string;
      dropdown: string;
    };
    textColor: string;
    logoBackgroundColor: string;
  };
  header: {
    primary: string;
    backgroundColor: string;
    itemsColor: string;
    textColor: string;
  };
  dashboard: {
    coloredCardTextColor: string;
    cardBackgroundColor: string;
    headerBackgroundColor: string;
    headerTextColor: string;
    sales: string;
    loyalty: string;
    rewards: string;
    reviews: string;
  };
  table: {
    header: {
      backgroundColor: string;
      textColor: string;
    };
    subHeaderBackgroundColor: string;
    subHeaderTextColor: string;
    statusColors: {
      primary: string;
      secondary: string;
      warning: string;
      danger: string;
    };
    body: {
      primaryBackgroundColor: string;
      secondaryBackgroundColor: string;
      textColor: string;
    };
  };
  form: {
    header: {
      primaryBackgroundColor: string;
      secondaryBackgroundColor: string;
      textColor: string;
      itemsColor: string;
      itemsTextColor: string;
    };
    backgroundColor: string;
  };
}
